export const QUESTION_TYPES = {
  singleOpenEndedMultipleLine: 'single-open-ended-multiple-line',
  singleOpenEndedSingleLine: 'single-open-ended-single-line',
  email: 'email',
  singleCloseEnded: 'single-close-ended',
  multipleCloseEnded: 'multiple-close-ended',
  yesNo: 'yes-no',
  ratingScale5: 'rating-scale-5',
  ratingScale7: 'rating-scale-7',
  netPromoterScore: 'net-promoter-score',
  titleAndDescription: 'title-and-description',
  reaction: 'reaction',
};
